/*
 * ============================================================
 * Début MSRP Ajout code - correctifs d’accessibilité centralisés
 * ============================================================
 */

(function () {
  'use strict';

  /**
   * Ajoute un aria-label uniquement lorsque l’élément
   * ne possède aucun nom accessible.
   */
  function addLabelIfMissing(element, label) {
    if (!element || !label) return;

    const currentLabel = element.getAttribute('aria-label');
    const labelledBy = element.getAttribute('aria-labelledby');
    const title = element.getAttribute('title');
    const visibleText = element.textContent
      ? element.textContent.trim()
      : '';

    if (
      !currentLabel &&
      !labelledBy &&
      !title &&
      !visibleText
    ) {
      element.setAttribute('aria-label', label);
    }
  }

  /**
   * Retourne le texte des icônes Material Symbols
   * contenues dans un bouton ou un lien.
   */
  function getMaterialIconNames(element) {
    if (!element) return '';

    return Array.from(
      element.querySelectorAll(
        [
          '.material-symbols-outlined',
          '.material-symbols-rounded',
          '.material-symbols-sharp'
        ].join(', ')
      )
    )
      .map(function (icon) {
        return icon.textContent
          ? icon.textContent.trim().toLowerCase()
          : '';
      })
      .filter(Boolean)
      .join(' ');
  }

  /*
   * ============================================================
   * Début MSRP Modification - boutons du header mobile et desktop
   * ============================================================
   */

  /**
   * Corrige les boutons et liens sans nom accessible
   * dans toutes les variantes du header :
   * mobile, desktop et header fixe.
   */
  function fixHeaderButtons() {
    document
      .querySelectorAll(
        [
          '.shopify-section-group-header-group button',
          '.shopify-section-group-header-group a',
          'header button',
          'header a',
          '.header button',
          '.header a',
          'a.header__icon',
          'button.header__icon'
        ].join(', ')
      )
      .forEach(function (element) {
        const icons = getMaterialIconNames(element);
        const href = element.getAttribute('href') || '';
        const ariaControls =
          element.getAttribute('aria-controls') || '';

        const classNames =
          typeof element.className === 'string'
            ? element.className.toLowerCase()
            : '';

        /*
         * Menu
         */
        if (
          icons.includes('menu') ||
          classNames.includes('menu') ||
          ariaControls.toLowerCase().includes('menu')
        ) {
          addLabelIfMissing(element, 'Ouvrir le menu');
        }

        /*
         * Recherche
         */
        if (
          icons.includes('search') ||
          classNames.includes('search') ||
          href === '/search' ||
          href.startsWith('/search?')
        ) {
          addLabelIfMissing(element, 'Rechercher');
        }

        /*
         * Compte client
         *
         * Le libellé est volontairement forcé afin de corriger
         * le lien desktop signalé par Lighthouse.
         */
        if (
          icons.includes('account_circle') ||
          icons.includes('account_box') ||
          icons.includes('person') ||
          classNames.includes('account') ||
          href === '/account' ||
          href.startsWith('/account/') ||
          href.includes('/account?')
        ) {
          element.setAttribute('aria-label', 'Mon compte');
        }

        /*
         * Panier
         */
        if (
          icons.includes('shopping_cart') ||
          icons.includes('shopping_bag') ||
          icons.includes('local_mall') ||
          classNames.includes('cart') ||
          href === '/cart' ||
          href.startsWith('/cart?')
        ) {
          addLabelIfMissing(element, 'Panier');
        }
      });
  }

  /*
   * ==========================================================
   * Fin MSRP Modification - boutons du header mobile et desktop
   * ==========================================================
   */

  /**
   * Corrige les noms accessibles et la structure ARIA
   * des carrousels Splide.
   */
  function fixSplideArrows() {
    document
      .querySelectorAll('.splide')
      .forEach(function (slider, index) {
        if (!slider.hasAttribute('role')) {
          slider.setAttribute('role', 'region');
        }

        if (
          !slider.hasAttribute('aria-label') &&
          !slider.hasAttribute('aria-labelledby')
        ) {
          slider.setAttribute(
            'aria-label',
            'Carrousel ' + (index + 1)
          );
        }

        slider
          .querySelectorAll('.splide__arrow--prev')
          .forEach(function (button) {
            button.setAttribute(
              'aria-label',
              'Diapositive précédente'
            );
          });

        slider
          .querySelectorAll('.splide__arrow--next')
          .forEach(function (button) {
            button.setAttribute(
              'aria-label',
              'Diapositive suivante'
            );
          });
      });
  }

  /**
   * Corrige le rôle des listes Splide afin d'autoriser
   * le rôle tabpanel appliqué aux éléments li des diapositives.
   *
   * La barre d'annonce retrouve ensuite son rôle de liste
   * dans fixAnnouncementSlides().
   */
  function fixSplideListRoles() {
    document
      .querySelectorAll('ul.splide__list')
      .forEach(function (list) {
        list.setAttribute('role', 'presentation');
      });
  }

  /**
   * Corrige les flèches des paginations classiques.
   */
  function fixPaginationButtons() {
    document
      .querySelectorAll(
        [
          '.pagination a',
          '.pagination button',
          '.pagination__item'
        ].join(', ')
      )
      .forEach(function (element) {
        const icons = getMaterialIconNames(element);

        const classNames =
          typeof element.className === 'string'
            ? element.className.toLowerCase()
            : '';

        if (
          icons.includes('keyboard_arrow_left') ||
          icons.includes('arrow_back') ||
          classNames.includes('prev')
        ) {
          addLabelIfMissing(element, 'Page précédente');
        }

        if (
          icons.includes('keyboard_arrow_right') ||
          icons.includes('arrow_forward') ||
          classNames.includes('next')
        ) {
          addLabelIfMissing(element, 'Page suivante');
        }
      });
  }

  /**
   * Met à jour, dans une même instance du composant,
   * les attributs qui font référence à un identifiant renommé.
   */
  function updateIdReferences(container, oldId, newId) {
    if (!container) return;

    container
      .querySelectorAll(
        [
          '[for]',
          '[aria-controls]',
          '[aria-labelledby]',
          '[aria-describedby]',
          '[aria-owns]',
          '[href]'
        ].join(', ')
      )
      .forEach(function (element) {
        if (element.getAttribute('for') === oldId) {
          element.setAttribute('for', newId);
        }

        [
          'aria-controls',
          'aria-labelledby',
          'aria-describedby',
          'aria-owns'
        ].forEach(function (attribute) {
          const value = element.getAttribute(attribute);

          if (!value) return;

          const ids = value.split(/\s+/);
          const updatedIds = ids.map(function (id) {
            return id === oldId ? newId : id;
          });

          if (updatedIds.join(' ') !== value) {
            element.setAttribute(attribute, updatedIds.join(' '));
          }
        });

        if (element.getAttribute('href') === '#' + oldId) {
          element.setAttribute('href', '#' + newId);
        }
      });
  }

  /**
   * Renomme uniquement les occurrences supplémentaires d’un ID.
   * La première occurrence reste inchangée pour préserver
   * la compatibilité avec le JavaScript natif du thème.
   */
  function fixDuplicateId(id) {
    const elements = Array.from(
      document.querySelectorAll('[id="' + id + '"]')
    );

    if (elements.length <= 1) return;

    elements
      .slice(1)
      .forEach(function (element, index) {
        let suffix = index + 2;
        let newId = id + '-msrp-' + suffix;

        while (document.getElementById(newId)) {
          suffix += 1;
          newId = id + '-msrp-' + suffix;
        }

        let container;

        if (id === 'search-popup') {
          container =
            element.closest('dialog-component') ||
            element.parentElement;
        } else {
          container = element.closest(
            [
              'form',
              'predictive-search',
              'search-modal',
              'dialog',
              'dialog-component'
            ].join(', ')
          ) || element.parentElement;
        }

        updateIdReferences(container, id, newId);
        element.id = newId;
      });
  }

  /**
   * Corrige dans le DOM les doublons générés par les différentes
   * variantes desktop, mobile et fixe du moteur de recherche.
   */
  function fixDuplicateSearchIds() {
    fixDuplicateId('q');
    fixDuplicateId('search-popup');
  }

  /**
   * Ajoute un rôle et un nom à la barre d’annonce.
   */
  function fixAnnouncementBar() {
    document
      .querySelectorAll(
        [
          '.announcement-bar',
          '.announcement-bar-wrapper',
          '[class*="announcement-bar"]'
        ].join(', ')
      )
      .forEach(function (bar) {
        if (!bar.hasAttribute('role')) {
          bar.setAttribute('role', 'region');
        }

        if (
          !bar.hasAttribute('aria-label') &&
          !bar.hasAttribute('aria-labelledby')
        ) {
          bar.setAttribute('aria-label', 'Annonces');
        }
      });
  }

  /**
   * Corrige la hiérarchie ARIA des diapositives
   * de la barre d’annonce.
   *
   * Lorsqu’un élément possède role="listitem",
   * son parent doit posséder role="list".
   */
  function fixAnnouncementSlides() {
    document
      .querySelectorAll(
        [
          '.announcement-bar .splide__list',
          '.announcement-bar-wrapper .splide__list',
          '[class*="announcement-bar"] .splide__list'
        ].join(', ')
      )
      .forEach(function (list) {
        list.setAttribute('role', 'list');

        if (
          !list.hasAttribute('aria-label') &&
          !list.hasAttribute('aria-labelledby')
        ) {
          list.setAttribute('aria-label', 'Liste des annonces');
        }

        list
          .querySelectorAll(':scope > .splide__slide')
          .forEach(function (slide) {
            slide.setAttribute('role', 'listitem');
          });
      });
  }

  /**
   * Désactive les aria-controls qui désignent
   * un élément inexistant.
   *
   * Un identifiant invalide peut faire échouer
   * certains audits ARIA.
   */
  function fixInvalidAriaControls() {
    document
      .querySelectorAll('[aria-controls]')
      .forEach(function (element) {
        const controlledId =
          element.getAttribute('aria-controls');

        if (!controlledId) return;

        const target =
          document.getElementById(controlledId);

        if (!target) {
          element.removeAttribute('aria-controls');
        }
      });
  }

  /**
   * Exécute tous les correctifs centralisés.
   */
  function applyAccessibilityFixes() {
    fixHeaderButtons();
    fixSplideArrows();
    fixSplideListRoles();
    fixPaginationButtons();
    fixDuplicateSearchIds();
    fixAnnouncementBar();
    fixAnnouncementSlides();
    fixInvalidAriaControls();
    /* Début modification MSRP - nom accessible des croix de popup image */
    document
      .querySelectorAll(
        'dialog-component.msrp-popup-image [data-ref="popup-close"]'
      )
      .forEach(function (button) {
        addLabelIfMissing(button, 'Fermer la fenêtre');
      });
    /* Fin de modification MSRP - nom accessible des croix de popup image */
  }

  /**
   * Première exécution après chargement du HTML.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      applyAccessibilityFixes,
      { once: true }
    );
  } else {
    applyAccessibilityFixes();
  }

  /**
   * Nouvelle exécution après les insertions dynamiques :
   *
   * - panier latéral ;
   * - recherche prédictive ;
   * - sliders ;
   * - applications Shopify ;
   * - header fixe créé après le chargement.
   */
  let observerTimer;

  const observer = new MutationObserver(function () {
    window.clearTimeout(observerTimer);

    observerTimer = window.setTimeout(function () {
      applyAccessibilityFixes();
    }, 150);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/*
 * ==========================================================
 * Fin MSRP Ajout code - correctifs d’accessibilité centralisés
 * ==========================================================
 */